import { create } from 'zustand';
import { EFormMode } from '@src/emp-3.0/types/common';

interface IWorkflowStore {
  isPanelOpen: boolean;
  setIsPanelOpen: (isPanelOpen: boolean) => void;
  formMode: EFormMode;
  setFormMode: (formMode: EFormMode) => void;
  hasChanged: boolean;
  setHasChanged: (hasChanged: boolean) => void;
  reset: () => void;
}

export const useWorkflowStore = create<IWorkflowStore>((set, get) => ({
  isPanelOpen: true,
  setIsPanelOpen: (isPanelOpen: boolean) => set({ isPanelOpen }),
  formMode: EFormMode.VIEW,
  setFormMode: (formMode: EFormMode) => set(() => ({ formMode })),
  hasChanged: false,
  setHasChanged: (hasChanged) => set({ hasChanged }),
  reset: () =>
    set({
      isPanelOpen: true,
      formMode: EFormMode.VIEW,
      hasChanged: false,
    }),
}));
